/*
 *  Bootstrap Nice Select Finnish (Finland) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['fi-FI'] = localisation.locales['fi'] = {
    formatSearch() {
        return "Etsiminen...";
    },
    formatHelpForTagging() {
        return "Luodaksesi omia tunnisteita, tarkenna syöttökenttä ja lisää se luetteloon painamalla Enter tai ',' tai 'Välilyönti'";
    }
}

export default localisation;